module.exports = __webpack_public_path__ + "static/img/card_3_1.8ba0dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_3_1.png
// module id = RWp2
// module chunks = 0